import axios from './axiosService';
import {orderBy} from 'lodash';

export default {
  async getSpace(spaceID) {
    return axios.get(`/api/spaces/${spaceID}`)
      .then(response => response.data);
  },
  async getAssets(spaceID) {
    return axios.get(`/api/spaces/${spaceID}/assets`)
      .then(response => response.data);
  },
  async getSpaces() {
    return axios.get(`/api/spaces`)
      .then(response => response.data);
  },
  async createSpace() {
    const form = {
      title: 'Untitled',
      status: 'Inactive',
    }
    return axios.post(`/api/spaces`, form)
      .then(response => response.data);
  },
  async changeAssetOrder(spaceID, assetIDs) {
    const form = {
      asset_ids: assetIDs,
    }
    return axios.patch(`/api/spaces/${spaceID}/assets/order`, form)
      .then(response => response.data);
  },
  async createFragment() {
    const form = {
      name: 'Untitled',
      dialog_title: 'Untitled',
      collapsed_height: '200px',
      status: 'Active',
    }
    return axios.post(`/api/space-fragments`, form)
      .then(response => response.data);
  },
  async getFragment(fragmentID) { // MLD-5030
    return axios.get(`/api/space-fragments/${fragmentID}`)
      .then(response => response.data);
  },
  async getFragments() { // MLD-5030
    return axios.get(`/api/space-fragments?include_spaces=1`)
      .then(response => orderBy(response.data, ['slug'], ['asc']));
  },
  async deleteFragment(fragmentID) {

  }
}
